module.exports = __webpack_public_path__ + "static/c5-3f6b53dc152ed47de1e5f064377b0245.jpg";